import { Spinner } from "@/components/ui/Spinner";
import cn from "twsx";

export function LoadingPage({
  className,
  label = "Loading…",
}: {
  className?: string;
  label?: string;
}) {
  return (
    <div
      aria-busy="true"
      aria-live="polite"
      className={cn(
        "grid h-full min-h-64 w-full flex-1 place-items-center px-6 py-16",
        className,
      )}
      role="status"
    >
      <div className="flex items-center gap-2 text-sm text-text-tertiary">
        <Spinner size="md" aria-hidden="true" />
        <span>{label}</span>
      </div>
    </div>
  );
}
